import React, { useState } from "react";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { Row, Col, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { logoutAdmin } from "../../store/actions";
import { useNavigate } from "react-router-dom";

export default function Confirmationmod(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.clear();
    window.location.replace("/login");
  };
  return (
    <Modal
      {...props}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="Depositmod_Colnoradius"
    >
      <Modal.Body>
        <div className="Depositmod_inner_mod">
          <div className="confirmation_mod text-center pt-4">
            <div className="text-center mb-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="80"
                height="80"
                viewBox="0 0 24 24"
              >
                <path
                  fill="#C11111"
                  d="M11.5 3a9.5 9.5 0 0 1 9.5 9.5a9.5 9.5 0 0 1-9.5 9.5A9.5 9.5 0 0 1 2 12.5A9.5 9.5 0 0 1 11.5 3m0 1A8.5 8.5 0 0 0 3 12.5a8.5 8.5 0 0 0 8.5 8.5a8.5 8.5 0 0 0 8.5-8.5A8.5 8.5 0 0 0 11.5 4M11 8v2h1V8zm0 4v5h1v-5z"
                />
              </svg>
            </div>

            <p>Do you want to Logout?</p>

            <div className="modal_butons d-flex align-items-center gap-3 justify-content-center mt-4 mb-3">
              <Button className="commonBtn" onClick={props.onhide}>
                No
              </Button>

              <Button className="commonBtn" onClick={handleLogout}>
                Yes
              </Button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
